import React from 'react'
import {Helmet} from "react-helmet";
import g from "glamorous";
import { NavLink, BrowserRouter, Switch, Route } from "react-router-dom";

export default ({ children, location, data }) => (
  <g.Div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: data.site.siteMetadata.description },
        { name: 'keywords', content: data.site.siteMetadata.keywords },
      ]}
    />

    {children()}
  </g.Div>
);

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
        description
        keywords
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js